<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconArrowRight_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M14.071 7.541 9.166 2.636a.65.65 0 0 0-1.042.748L9.921 7H3a1 1 0 0 0 0 2h6.921l-1.797 3.616a.65.65 0 0 0 1.042.749l4.905-4.905a.65.65 0 0 0 0-.919"
    />
</svg>
